import {ReactNode} from 'react';
import {useParams} from 'react-router-dom';
import {Navigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';
import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';

export interface CategoryGuardProps {
  children(category: CreatePublicServiceConsentRequest.category): ReactNode;
}

function CategoryGuard({children}: CategoryGuardProps): JSX.Element {
  const params = useParams();

  if (!params.category) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }

  return <>{children(params.category as CreatePublicServiceConsentRequest.category)}</>;
}

export default CategoryGuard;
